import { actionTypes, mutationTypes } from '../types';
import { uiComponents, uiStates } from '../tools/viewState';
import { i18n } from '@/tools/i18n';
import { getFigcaptionTitle } from '../tools/helpers';

export default {
	init() {
		[...this.$el.querySelectorAll('.post--3d')].forEach(post => {
			post.addEventListener('click', () => {
				const mediaID = post.querySelector('[media-id]').getAttribute('media-id');
				this.$store.dispatch(actionTypes.viewer3dLoadID, { mediaObjectID: mediaID });
				this.$store.commit(mutationTypes.viewStateSetUiState, {
					id: uiComponents.ui3d,
					uiState: uiStates.maximised,
				});
			});

			// screenreader compat
			const icon = post.querySelector('.element__fullimage');
			if (icon) {
				icon.setAttribute('role', 'button');
				icon.setAttribute('tabindex', 0);
				icon.setAttribute('aria-label', `${i18n.t('model3dShow')} ${getFigcaptionTitle(post)}`);
			}

			const description = post.querySelector('.element__caption__text');
			if (description) {
				description.setAttribute('role', 'text');
				description.setAttribute('tabindex', 0);
				description.setAttribute('aria-label', `${i18n.t('model3dDescription')} ${description.textContent}`);
			}
			[...post.querySelectorAll('.element__caption__headline, .element__caption__time')].forEach(element =>
				element.setAttribute('aria-hidden', true)
			);
		});
	},
};
